import React, { useState, useEffect } from "react";
import './CountdownTimer.css'

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    const fetchCountdown = async () => {
      try {
        const response = await fetch("https://admin.riymay.com/api/v1/admin/count-down");
        const data = await response.json();
        if (data.length > 0) {
          const fromTime = new Date(data[0].fromTime).getTime();
          const toTime = new Date(data[0].toTime).getTime();
          setEndTime(toTime);
          startCountdown(toTime);
        }
      } catch (error) {
        console.error("Error fetching countdown data:", error);
      }
    };

    fetchCountdown();
  }, []);

  const startCountdown = (toTime) => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = toTime - now;

      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);
  };

  return (
    <div className="countdown-container">
      <span className="countdown-title">Countdown For Next Drop  </span>
      <div className="timer-container">
        <div className="timer-box"><span>{timeLeft.days}</span> Days</div>
        <div className="timer-box"><span>{timeLeft.hours}</span> Hours</div>
        <div className="timer-box"><span>{timeLeft.minutes}</span> Minutes</div>
        <div className="timer-box"><span>{timeLeft.seconds}</span> Seconds</div>
      </div>
    </div>
  );
};

export default CountdownTimer;